import React, { useCallback, useRef, useState, useEffect } from "react";
import {
  AppProvider,
  ActionList,
  Card,
  TextField,
  Text,
  ContextualSaveBar,
  FormLayout,
  Modal,
  Frame,
  Layout,
  Loading,
  Navigation,
  Page,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  Toast,
  TopBar,
  List,
} from "@shopify/polaris";
import {
  ExitIcon,
  PersonFilledIcon,
  DeliveryFilledIcon,
  OrderFilledIcon,
  TeamIcon,
  InventoryFilledIcon,
  ListBulletedIcon,
  BookIcon,
  ClipboardCheckFilledIcon,
  ReturnIcon,
} from "@shopify/polaris-icons";
import Cookies from "js-cookie";
import logoImg from "../Assets/Images/logoWhite.svg";
import { useNavigate } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import { ListGroup } from "react-bootstrap";

function NavigationLayout(props) {
  // const iconContent = () => {
  //   return (
  //     <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  //       <circle cx="10" cy="10" r="10" fill="rebeccapurple" />
  //       <circle cx="10" cy="10" r="6" fill="currentColor" />
  //       <circle cx="10" cy="10" r="3" />
  //     </svg>
  //   );
  // };
  const navigate = useNavigate();
  const defaultState = useRef({
    emailFieldValue: "dharma@jadedpixel.com",
    nameFieldValue: "Jaded Pixel",
  });
  const skipToContentRef = useRef(null);

  const [toastActive, setToastActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [userMenuActive, setUserMenuActive] = useState(false);
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  const [nameFieldValue, setNameFieldValue] = useState(
    defaultState.current.nameFieldValue
  );
  const [emailFieldValue, setEmailFieldValue] = useState(
    defaultState.current.emailFieldValue
  );
  const [storeName, setStoreName] = useState(
    defaultState.current.nameFieldValue
  );
  const [supportSubject, setSupportSubject] = useState("");
  const [supportMessage, setSupportMessage] = useState("");

  const handleSubjectChange = useCallback(
    (value) => setSupportSubject(value),
    []
  );
  const handleMessageChange = useCallback(
    (value) => setSupportMessage(value),
    []
  );
  const handleDiscard = useCallback(() => {
    setEmailFieldValue(defaultState.current.emailFieldValue);
    setNameFieldValue(defaultState.current.nameFieldValue);
    setIsDirty(false);
  }, []);
  const handleSave = useCallback(() => {
    defaultState.current.nameFieldValue = nameFieldValue;
    defaultState.current.emailFieldValue = emailFieldValue;

    setIsDirty(false);
    setToastActive(true);
    setStoreName(defaultState.current.nameFieldValue);
  }, [emailFieldValue, nameFieldValue]);
  const handleNameFieldChange = useCallback((value) => {
    setNameFieldValue(value);
    value && setIsDirty(true);
  }, []);
  const handleEmailFieldChange = useCallback((value) => {
    setEmailFieldValue(value);
    value && setIsDirty(true);
  }, []);
  const handleSearchResultsDismiss = useCallback(() => {
    setSearchActive(false);
    setSearchValue("");
  }, []);
  const handleSearchFieldChange = useCallback((value) => {
    setSearchValue(value);
    setSearchActive(value.length > 0);
  }, []);
  const toggleToastActive = useCallback(
    () => setToastActive((toastActive) => !toastActive),
    []
  );
  const toggleUserMenuActive = useCallback(
    () => setUserMenuActive((userMenuActive) => !userMenuActive),
    []
  );
  const toggleMobileNavigationActive = useCallback(
    () =>
      setMobileNavigationActive(
        (mobileNavigationActive) => !mobileNavigationActive
      ),
    []
  );
  const toggleIsLoading = useCallback(
    () => setIsLoading((isLoading) => !isLoading),
    []
  );
  const toggleModalActive = useCallback(
    () => setModalActive((modalActive) => !modalActive),
    []
  );

  const toastMarkup = toastActive ? (
    <Toast onDismiss={toggleToastActive} content="Changes saved" />
  ) : null;

  const userMenuActions = [
    // {
    //   items: [
    //     {
    //       content: "Your profile",
    //       icon: ProfileMinor,
    //       onAction: () => navigate("/profile"),
    //     },
    //   ],
    // },
    {
      items: [
        {
          content: "Log out",
          icon: ExitIcon,

          onAction: () => {
            axios
              .post(`/logout`)
              .then((result) => {
                navigate("/");
              })
              .catch((err) => {
                Cookies.set("lms-accesstoken", null);
                navigate("/");
              });
          },
        },
      ],
    },
  ];
  const customIcon = {
    viewBox: "0 0 20 20",
    body: '<g transform="scale(0.5)"><path d="M16 0 C6 0 2 4 2 14 L2 22 L6 24 L6 30 L26 30 L26 24 L30 22 L30 14 C30 4 26 0 16 0 M9 12 A4.5 4.5 0 0 1 9 21 A4.5 4.5 0 0 1 9 12 M23 12 A4.5 4.5 0 0 1 23 21 A4.5 4.5 0 0 1 23 12"></path></g>',
  };
  const contextualSaveBarMarkup = isDirty ? (
    <ContextualSaveBar
      message="Unsaved changes"
      saveAction={{
        onAction: handleSave,
      }}
      discardAction={{
        onAction: handleDiscard,
      }}
    />
  ) : null;

  const userMenuMarkup = (
    <TopBar.UserMenu
      actions={userMenuActions}
      name={Cookies.get("lms-name") && Cookies.get("lms-name")}
      initials={
        Cookies.get("lms-name") &&
        Cookies.get("lms-name").split(" ")[0].charAt(0) +
          " " +
          Cookies.get("lms-name").split(" ")[1].charAt(0)
      }
      open={userMenuActive}
      onToggle={toggleUserMenuActive}
    />
  );

  const searchResultsMarkup = (
    <ActionList
      items={[
        { content: "Shopify help center" },
        { content: "Community forums" },
      ]}
    />
  );

  const searchFieldMarkup = (
    <TopBar.SearchField
      onChange={handleSearchFieldChange}
      value={searchValue}
      placeholder="Search"
    />
  );

  const topBarMarkup = (
    <TopBar
      showNavigationToggle
      userMenu={userMenuMarkup}
      // searchResultsVisible={searchActive}
      // searchField={searchFieldMarkup}
      // searchResults={searchResultsMarkup}
      // onSearchResultsDismiss={handleSearchResultsDismiss}
      onNavigationToggle={toggleMobileNavigationActive}
      // logoSuffix
    />
  );

  const navigationMarkup = (
    <Navigation location="/">
      <Navigation.Section
        items={[
          // {
          //   url: "/",
          //   onClick: () => navigate("/admin/dashboard"),
          //   label: "Dashboard",
          //   icon: OrderFilledIcon,
          //   selected: window.location.href.indexOf("/admin/dashboard") > -1,
          // },
          {
            url: "/",
            onClick: () => navigate("/admin/supplier-warehouse"),
            label: "Supplier Warehouse",
            icon: OrderFilledIcon,
            selected:
              window.location.href.indexOf("/admin/supplier-warehouse") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/sorting-center"),
            label: "Sorting Center",
            icon: OrderFilledIcon,
            selected:
              window.location.href.indexOf("/admin/sorting-center") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/warehouse-beirut"),
            label: "Warehouse Beirut",
            icon: OrderFilledIcon,
            selected:
              window.location.href.indexOf("/admin/warehouse-beirut") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/returns"),
            label: "Returns",
            icon: OrderFilledIcon,
            selected: window.location.href.indexOf("/admin/returns") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/closed"),
            label: "Closed",
            icon: OrderFilledIcon,
            selected: window.location.href.indexOf("/admin/closed") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/bulk-order-transfer"),
            label: "Bulk Order Transfer",
            icon: OrderFilledIcon,
            selected:
              window.location.href.indexOf("/admin/bulk-order-transfer") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/bulk-returns"),
            label: "Bulk Returns",
            icon: OrderFilledIcon,
            selected: window.location.href.indexOf("/admin/bulk-returns") > -1,
          },

          // {
          //   url: "/",
          //   onClick: () => navigate("/admin/warehouse-beirut"),
          //   label: "Warehouse Beirut",
          //   icon: OrderFilledIcon,
          //   selected:
          //     window.location.href.indexOf("/admin/warehouse-beirut") > -1,
          // },
          {
            url: "/",
            onClick: () => navigate("/admin/drivers"),
            label: "Drivers",
            icon: DeliveryFilledIcon,
            selected: window.location.href.indexOf("/admin/drivers") > -1,
          },
        ]}
      ></Navigation.Section>
      {/* <Navigation.Section
        separator
        items={[
          {
            label: "Settings",
            url: "/",
            onClick: () => navigate("/admin/settings/users-and-permissions"),
            icon: SettingsFilledIcon,
            selected: window.location.href.indexOf("/admin/settings") > -1,
            subNavigationItems: [
              {
                onClick: () =>
                  navigate("/admin/settings/users-and-permissions"),
                selected:
                  window.location.href.indexOf(
                    "/admin/settings/users-and-permissions"
                  ) > -1 && true,
                label: "Users and Permissions",
                icon: PersonFilledIcon,
              },
            ],
          },
        ]}
      /> */}
    </Navigation>
  );
  const loadingMarkup = isLoading ? <Loading /> : null;

  const skipToContentTarget = (
    <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
  );

  const actualPageMarkup = (
    <Page title="Account">
      <Layout>
        {skipToContentTarget}
        <Layout.AnnotatedSection
          title="Account details"
          description="Jaded Pixel will use this as your account information."
        >
          <Card sectioned>
            <FormLayout>
              <TextField
                label="Full name"
                value={nameFieldValue}
                onChange={handleNameFieldChange}
              />
              <TextField
                type="email"
                label="Email"
                value={emailFieldValue}
                onChange={handleEmailFieldChange}
              />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>
      </Layout>
    </Page>
  );

  const loadingPageMarkup = (
    <SkeletonPage>
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <Text>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText lines={9} />
            </Text>
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );

  const pageMarkup = isLoading ? loadingPageMarkup : actualPageMarkup;

  const modalMarkup = (
    <Modal
      open={modalActive}
      onClose={toggleModalActive}
      title="Contact support"
      primaryAction={{
        content: "Send",
        onAction: toggleModalActive,
      }}
    >
      <Modal.Section>
        <FormLayout>
          <TextField
            label="Subject"
            value={supportSubject}
            onChange={handleSubjectChange}
          />
          <TextField
            label="Message"
            value={supportMessage}
            onChange={handleMessageChange}
            multiline
          />
        </FormLayout>
      </Modal.Section>
    </Modal>
  );

  const theme = {
    colors: {
      surface: "#FFFFFF",
      onsurface: "#212B36",
    },
  };
  const logo = {
    width: 150,

    // topBarSource: logoImg,
    // url: "/admin/employees",
    // accessibilityLabel: "Jaded Pixel",
  };

  useEffect(() => {
    console.log("aaa=", Cookies.get("lms-name"));
  }, []);

  return (
    <div style={{ height: "500px" }}>
      <AppProvider
        // theme={theme}
        i18n={{
          Polaris: {
            Avatar: {
              label: "Avatar",
              labelWithInitials: "Avatar with initials {initials}",
            },
            ContextualSaveBar: {
              save: "Save",
              discard: "Discard",
            },
            TextField: {
              characterCount: "{count} characters",
            },
            TopBar: {
              toggleMenuLabel: "Toggle menu",

              SearchField: {
                clearButtonLabel: "Clear",
                search: "Search",
              },
            },
            Modal: {
              iFrameTitle: "body markup",
            },
            Frame: {
              skipToContent: "Skip to content",
              Navigation: {
                closeMobileNavigationLabel: "Close navigation",
              },
            },
          },
        }}
      >
        <Frame
          topBar={topBarMarkup}
          navigation={navigationMarkup}
          showMobileNavigation={mobileNavigationActive}
          onNavigationDismiss={toggleMobileNavigationActive}
          skipToContentTarget={skipToContentRef.current}
          logo={logo}
        >
          {props.children}
        </Frame>
      </AppProvider>
    </div>
  );
}
export default React.memo(NavigationLayout);
